import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import Index from "./pages/Index";

// Lazy load non-critical pages to reduce bundle size
const Auth = lazy(() => import("./pages/Auth"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const GoogleCalendar = lazy(() => import("./pages/GoogleCalendar"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Terms = lazy(() => import("./pages/Terms"));
const Cookies = lazy(() => import("./pages/Cookies"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/auth" element={
            <Suspense fallback={<div className="min-h-screen bg-muted/20 animate-pulse" />}>
              <Auth />
            </Suspense>
          } />
          <Route path="/dashboard" element={
            <Suspense fallback={<div className="min-h-screen bg-muted/20 animate-pulse" />}>
              <Dashboard />
            </Suspense>
          } />
          <Route path="/termos-de-servicos" element={
            <Suspense fallback={<div className="min-h-screen bg-muted/20 animate-pulse" />}>
              <Terms />
            </Suspense>
          } />
          <Route path="/politica-de-privacidade" element={
            <Suspense fallback={<div className="min-h-screen bg-muted/20 animate-pulse" />}>
              <Privacy />
            </Suspense>
          } />
          <Route path="/terms" element={
            <Suspense fallback={<div className="min-h-screen bg-muted/20 animate-pulse" />}>
              <Terms />
            </Suspense>
          } />
          <Route path="/cookies" element={
            <Suspense fallback={<div className="min-h-screen bg-muted/20 animate-pulse" />}>
              <Cookies />
            </Suspense>
          } />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={
            <Suspense fallback={<div className="min-h-screen bg-muted/20 animate-pulse" />}>
              <NotFound />
            </Suspense>
          } />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
